export default __webpack_public_path__ + "static/media/icon.3fe806a6.png";